import { Box, useTheme } from "@mui/material";

const ListRowDivider = () => {
    const theme = useTheme();
    const color =
        theme.palette.mode === "dark"
            ? theme.palette.secondary.main
            : theme.palette.divider;
    return <Box sx={{ height: "1px", background: color, flexShrink: 0 }} />;
};

export default ListRowDivider;
